import { render, staticRenderFns } from "./SampleOrderInvoice.vue?vue&type=template&id=7d48803e&scoped=true&"
import script from "./SampleOrderInvoice.vue?vue&type=script&lang=js&"
export * from "./SampleOrderInvoice.vue?vue&type=script&lang=js&"
import style0 from "./SampleOrderInvoice.vue?vue&type=style&index=0&id=7d48803e&prod&lang=css&"
import style1 from "./SampleOrderInvoice.vue?vue&type=style&index=1&id=7d48803e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d48803e",
  null
  
)

export default component.exports